import React, {useState, useContext, useEffect} from "react";
import { useTranslation, Trans } from 'react-i18next';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {DataContext} from '../contexts/DataContext';
import {Divider} from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Tooltip from '@mui/material/Tooltip';
import AdmSelection from "./admSelection";
import SliderYear from "./sliderYear";
import StormsTreeView from "./stormsTreeView";
import CloseButton from "./closeButton";
import {fetchJSON} from "../utils/fetchFunctions";
import {markOnce} from "../utils/miscFunctions";
import CircularProgress from "@mui/material/CircularProgress";

export default function SelectedStorm(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const {allStorms} = props;

    const { t } = useTranslation();

    const [currentStorms, setCurrentStorms] = useState([])
    const [latestStorms, setLatestStorms] = useState([])
    const [pastStorms, setPastStorms] = useState([])
    const [pastStormsSeason, setPastStormsSeason] = useState([])
    const {
        storm,
        currentStorm,
        pastStorm,
        updatePastStorm,
        current_storm,
        updateStorm,
        selectedStorm,
        updateSelectedStorm,
        updateCurrentStorm,
        updateCurrent_Storm,
        latest_storms,
        updateLatestStorms,
        url_root,
        updateStormsToShow,
        trackLoading,
        stepsSettled
    } = useContext(DataContext);

    // the menu is greyed out until the lists of storms it displays have arrived
    const menuReady = stepsSettled(['pastStorms', 'pastSeason', 'seasonStorms', 'storms'])
    useEffect(() => {
        if (menuReady) markOnce('app:primary-ready')
    }, [menuReady])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        //updateStormsToShow([]);
    };

    const handleChange = (event) => {
        updateStorm(event.target.value);
    };

    const handleSelectedStormSeason = (event) => {
        setAnchorEl(false)
        if (latestStorms.map(x => x.id).includes(event.target.value)) {
            updateSelectedStorm(latestStorms.filter((i) => i.id === event.target.value)[0]);
        } else if (currentStorms.map(x => x.id).includes(event.target.value)) {
            updateSelectedStorm(currentStorms.filter((i) => i.id === event.target.value)[0]);
        } else {
            updateSelectedStorm(pastStorms.filter((i) => i.id === event.target.value)[0]);
        }
    }

    useEffect(() => {
        trackLoading(fetchJSON(url_root + 'pastStorms.json') //note here the local path is relative to "index.html" instead of "index.js"
            .then(resp => resp.jtwc_history)
            .then(resp => resp.map(x => ({
                storm_name: x.storm_name,
                id: x.id,
                year: x.year,
                nc: x.nc ? url_root + x.nc : null,
                shp: x.shp ? url_root + x.shp : null,
                losses: x.losses ? url_root + x.losses : null,
                type: 'past',
                bbox: x.bbox
            })))
            .then(resp => {
                //updateCurrentStorm(false)
                setPastStorms(resp)
            }), 'pastStorms')
    }, [])

    useEffect(() => {
        trackLoading(fetchJSON(url_root + 'latestStorms_15as.json')  // Use the correct path for your JSON file
            .then(data => {
                const storms = data.mpres_data;

                // Create an empty object to hold the storms grouped by year
                const groupedStorms = {};

                // Iterate over each storm and group it by the year extracted from the ID
                storms.forEach(storm => {
                    const year = storm.id.slice(-4); // Get the last 4 digits of the ID (e.g., "1995")
                    if (!groupedStorms[year]) {
                        groupedStorms[year] = [];
                    }
                    groupedStorms[year].push(storm);
                });

                // Update the state with the grouped storms
                setPastStormsSeason(groupedStorms);
            }), 'pastSeason');
    }, []);


    useEffect(() => {
        trackLoading(fetchJSON(url_root + 'latestStorms_15as.json') //note here the local path is relative to "index.html" instead of "index.js"
            .then(resp => resp.mpres_data)
            .then(resp => resp.map(x => ({
                storm_name: x.storm_name,
                id: x.id,
                shp: url_root + x.shp,
                nc: x.nc ? url_root + x.nc : null,
                losses: x.losses ? url_root + x.losses : '',
                type: 'season',
                bbox: x.bbox
            })))
            .then(resp => {
                //updateCurrentStorm(false)
                setLatestStorms(resp)
                //updateLatestStorms(latestStorms)
            }), 'seasonStorms')
    }, [])


    return (
        <Box sx={{ minWidth: 120, boxShadow: 20, marginLeft:2}}>
            <Tooltip placement={'top'} title={t('buttons.storms.helper')}>
                <span>
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    disabled={!menuReady}
                    endIcon={menuReady ? null : <CircularProgress size={14} color="inherit" />}
                >
                    {/*                <Trans i18nKey='buttons.storms'>
                    Storms
                </Trans>*/}
                    {t('buttons.storms.title')}
                </Button>
                </span>
            </Tooltip>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <CloseButton handleClose={handleClose}/>
                {/*TODO: check what each parameter contains exactly*/}
                <StormsTreeView pastStormsSeason={pastStormsSeason} pastStorms={pastStorms} latestStorms={latestStorms} allStorms={allStorms}/>

            </Menu>



        </Box>
    );
}
